'use client';

import { c as _c } from "react/compiler-runtime";
import { markNestedTypes } from '@cc-shopping/structured-content-renderer/utils';
import { AdvertiserDisclosure } from '@cc-shopping/ui/composites/AdvertiserDisclosure';
import { BlockDisclosure } from '@cc-shopping/ui/composites/AdvertiserDisclosure/BlockDisclosure';
import { Box, Typography } from '@mui/material';
import Grid from '@mui/material/Grid';
import { Fragment } from 'react';
import { StructuredContentRenderer } from 'src/features/content/StructuredContentRenderer';
import { BreadcrumbRedesigned } from 'src/features/navigation/BreadcrumbRedesigned';
import { useReviewContext } from '../Context';
import AuthorsAndEditors from './AuthorsAndEditors';
export default function ReviewHeader(t0) {
  const $ = _c(29);
  const {
    formattedDate
  } = t0;
  const review = useReviewContext();
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      marginBottom: {
        xs: 3.5,
        md: "35px"
      }
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  let t2;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      mt: "2rem",
      mb: "2rem",
      whiteSpace: "nowrap"
    };
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const t3 = review.slug || "Credit Card Review";
  let t4;
  if ($[2] !== review.breadcrumb.page.title || $[3] !== t3) {
    t4 = <Grid sx={t2} size={6}><BreadcrumbRedesigned source="REVIEWS" slug={t3} text={review.breadcrumb.page.title} /></Grid>;
    $[2] = review.breadcrumb.page.title;
    $[3] = t3;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  let t6;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = {
      marginTop: 2
    };
    t6 = {
      xs: 12,
      md: 8
    };
    $[5] = t5;
    $[6] = t6;
  } else {
    t5 = $[5];
    t6 = $[6];
  }
  let t7;
  let t8;
  if ($[7] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = {
      gap: 2
    };
    t8 = <AdvertiserDisclosure position="bottom-left" />;
    $[7] = t7;
    $[8] = t8;
  } else {
    t7 = $[7];
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = {
      fontSize: "2rem"
    };
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] !== review.title) {
    t10 = <Typography component="h1" variant="xlHeadline" sx={t9}>{review.title}</Typography>;
    $[10] = review.title;
    $[11] = t10;
  } else {
    t10 = $[11];
  }
  let t11;
  if ($[12] !== review.synopsis) {
    t11 = review.synopsis && <Box sx={{
      marginTop: 3
    }}><StructuredContentRenderer doc={markNestedTypes(review.synopsis)} /></Box>;
    $[12] = review.synopsis;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  let t12;
  if ($[14] !== t10 || $[15] !== t11) {
    t12 = <Grid container={true} sx={t7}>{t8}{t10}{t11}</Grid>;
    $[14] = t10;
    $[15] = t11;
    $[16] = t12;
  } else {
    t12 = $[16];
  }
  let t13;
  if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = {
      gap: 1
    };
    $[17] = t13;
  } else {
    t13 = $[17];
  }
  let t14;
  if ($[18] !== formattedDate) {
    t14 = <AuthorsAndEditors formattedDate={formattedDate} />;
    $[18] = formattedDate;
    $[19] = t14;
  } else {
    t14 = $[19];
  }
  let t15;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <BlockDisclosure />;
    $[20] = t15;
  } else {
    t15 = $[20];
  }
  let t16;
  if ($[21] !== t14) {
    t16 = <Grid container={true} sx={t13}>{t14}{t15}</Grid>;
    $[21] = t14;
    $[22] = t16;
  } else {
    t16 = $[22];
  }
  let t17;
  if ($[23] !== t12 || $[24] !== t16) {
    t17 = <Grid sx={t5} size={t6}>{t12}{t16}</Grid>;
    $[23] = t12;
    $[24] = t16;
    $[25] = t17;
  } else {
    t17 = $[25];
  }
  let t18;
  if ($[26] !== t17 || $[27] !== t4) {
    t18 = <Fragment><Grid container={true} sx={t1}>{t4}{t17}</Grid></Fragment>;
    $[26] = t17;
    $[27] = t4;
    $[28] = t18;
  } else {
    t18 = $[28];
  }
  return t18;
}